<template>
  <div>
    <main-header></main-header>
    <div class="flex flex-wrap layout">
      <div class="left">
        <div class="white-card flex-col justify-center mb-3" v-if="children.length">
          <p class="text-lg font-black text-center h-">
            <span class="textTeal">Verifier le &nbsp;</span>
            <span class="textGray">progres&nbsp;</span>
            <span class="textTeal">de:</span>
          </p>
          <div class="my-3 smallHeight bg-teal-500 w-1/6 mx-auto"></div>
          <div class="pgr font-semibold">
            <menu-user v-for="(u,i) in children" :user="u" :key="i"/>
          </div>
        </div>
        <div class="white-card flex-col justify-center">
          <p class="text-lg font-black text-center h-">
            <span class="textTeal">Gerer un &nbsp;</span>
            <span class="textGray">profil&nbsp;</span>
          </p>
          <div class="my-3 smallHeight bg-teal-500 w-1/6 mx-auto"></div>
          <ul class="profileNav m-0 p-0">
            <router-link tag="li" class="nav-el" :to="{name: 'profile',query: {section:'parent'}}">
              <i class="textTeal mr-6 fas fa-users fa-2x"></i>
              <span class="text-black">Profil des parents</span>
            </router-link>
            <router-link tag="li" class="nav-el" :to="{name: 'profile',query: {section:'student'}}">
              <i class=" textTeal mr-6  fas fa-graduation-cap fa-2x"></i>
              <span class="text-black">Profil des eleves</span>
            </router-link>
            <router-link tag="li" class="nav-el" :to="{name: 'profile',query: {section:'offer'}}">
              <i class="fas fa-book fa-2x textTeal mr-6"></i>
              <span class="text-black">Abonnements</span>
            </router-link>
          </ul>
        </div>
      </div>
      <div class="center">
        <b-alert variant="success" show="" dismissible v-if="paymentSuccess">Votre abonnement a été payé</b-alert>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import mainHeader from "./MainHeader";
import {mapGetters} from 'vuex'
import MenuUser from "@/components/collapsable_container/components/MenuUser";

export default {
  components: {
    MenuUser,
    mainHeader,
  },
  data() {
    return {
      activeIndex: 0
    };
  },
  computed: {
    ...mapGetters(['user', 'children']),
    currentStudent() {
      return this.children[this.activeIndex]
    },
    paymentSuccess() {
      return this.$route.query.payment === 'success'
    }
  },
  methods: {
    handleFlo: function () {

    },
    handleAdr: function () {
      this.accountWho = "Adrien";
      this.showFloriane1 = false;
      this.showAdrien1 = true;
      this.showMervine1 = false;
    },
    handleMer: function () {
      this.accountWho = "Mervine";
      this.showFloriane1 = false;
      this.showAdrien1 = false;
      this.showMervine1 = true;
    },
    toHome: function () {
    }
  }
};
</script>

<style scoped lang="scss">
@import url("../assets/css/tailwind.css");

.divider-holder {
  position: relative;
}

.iconHolder {
  width: 40px;
  margin-right: 10px;
}

.textTeal {
  color: #00aaa5;
}

.textGray {
  color: #787878;
}

.fa-2x {
  width: 30px !important;
}

.layout {
  padding: 30px;

  .left {
    flex: 0 300px;
  }

  .center {
    margin-left: 20px;
    flex-shrink: 0;
    flex-grow: 1;
    flex-basis: 200px;
    @include md() {
      margin-left: 0;
      margin-top: 20px
    }
  }
}

.nav-el {
  display: flex;
  align-items: center;
  padding: 5px 15px;
  cursor: pointer;

  &:hover {
    background: #ccc;
    color: $green;
  }
}

</style>
